import {
    Box, Grid, Typography, Button, Card, CardContent,
    CardActions, Dialog, DialogContent
} from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';

const ShippingAddresses = ({
    shippingAddresses, open, handleOpen, handleClose, selectAddress
}) => {
    return (
        <Box>
            {
                shippingAddresses.length > 0 &&
                <>
                    <Button onClick={handleOpen} variant="contained" sx={{textTransform: 'none'}} startIcon={<HomeIcon />}>Mis direcciones</Button>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        maxWidth='xl'
                        fullWidth={true}
                    >
                        <DialogContent>
                            <Typography variant="h5" paragraph>Mis direcciones de envío</Typography>
                            <Grid container spacing={3}>
                                {
                                    shippingAddresses.map(e =>
                                        <Grid item xl={4} lg={4} md={6} sm={12} xs={12}
                                            key={e._id}>
                                            <Card sx={{ width: '100%', boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)' }}>
                                                <CardContent>
                                                    <Typography variant='body1' sx={{ fontWeight: '600' }}>{e.name} {e.lastname}</Typography>
                                                    <Typography variant='body1'>{`${e.street} #${e.ext_num} `}
                                                        {e.int_num ? `interior ${e.int_num}` : ''}</Typography>
                                                    <Typography variant='body1'>{e.colony}</Typography>
                                                    <Typography variant='body1'>{`${e.city}, ${e.state}, C.P.${e.postalcode}`}</Typography>
                                                    <Typography variant='body1'>Teléfono: {e.tel}</Typography>
                                                </CardContent>
                                                <CardActions>
                                                    <Button size="small" onClick={selectAddress(e._id)}>Seleccionar</Button>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                    )}
                            </Grid>
                        </DialogContent>
                    </Dialog>
                </>
            }
        </Box>
    );
};

export default ShippingAddresses;